<template>
  <div
    v-if="visible"
    class="sticky -top-[var(--sera-main-padding)] z-30 -mx-[var(--sera-main-padding)] -mt-[var(--sera-main-padding)] mb-[var(--sera-main-padding)] flex h-14 items-center gap-2 border-b border-solid border-primary-200 bg-primary-50 py-1.5 pl-4 pr-1"
    data-cy="mobile-view-banner"
  >
    <div class="min-w-0 flex-1 text-sm leading-5 text-gray-900">
      <div>You're viewing the optimized mobile view</div>
      <button
        type="button"
        class="-my-3 inline-flex h-11 items-center font-medium text-primary-700 underline underline-offset-2"
        data-cy="mobile-view-banner-switch"
        @click="switchTo('old_scheduler', 'banner')"
      >
        Use Old Scheduler
      </button>
    </div>
    <button
      type="button"
      class="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-gray-500"
      aria-label="Hide this message"
      data-cy="mobile-view-banner-dismiss"
      @click="dismiss"
    >
      <CloseIcon class="w-4" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { trackMobileWebEvent } from "@/lib/pendo";

import CloseIcon from "@/images/x.svg?component";
import { useSchedulerChoice } from "@/SchedulerV2/useSchedulerChoice";

// The strip that tells a phone user they are on the optimized layout, with the
// way off it. It pins under the app header the way the control row does (see
// ScheduleControlRow for the padding arithmetic); its bottom margin hands the
// page padding back so the row lands flush beneath it.
//
// Only the close control dismisses, and per browser. The switch changes the
// phone choice instead, so switching back later shows the band again. Storage
// can be blocked or throw (private windows, cleared site data); the band then
// shows on every visit.
const STORAGE_KEY = "scheduler-mobile-view-banner-dismissed";

const emit = defineEmits<{
  (e: "visible", visible: boolean): void;
}>();

const { switchTo } = useSchedulerChoice();

const visible = ref(
  (() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) !== "1";
    } catch {
      return true;
    }
  })()
);

const dismiss = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    // The band returns next visit.
  }
  visible.value = false;
  trackMobileWebEvent("schedule_banner_dismiss");
};

// The page sets the control row's sticky offset from this.
watch(visible, (isVisible) => emit("visible", isVisible), { immediate: true });
</script>
